// @flow
import Company from 'models/Company';

export default class HomeApplicationIncome {
  id: string;
  income_source: string;
  everybodys_income: number;
  seniority_years: string;
  position: string;
  number_of_homies: number;
  homies: [];
  subsidiaries_number: number;
  current_living_situation: string;
  number_of_cars: number;
  mortgage_credit: boolean;
  automotive_credit: boolean;
  credit_card: boolean;
  other_credits: boolean;
  credit_card_last_digits: string;
  credit_card_issued_months: number;
  supermarket_expenses: number;
  leisure_expenses: number;
  monthly_savings: number;
  identity_checked: boolean;
  employment_checked: boolean;
  education_checked: boolean;
  blacklisted: boolean;
  money_laundering_verified: boolean;
  demands_verified: boolean;
  income_all_verified: boolean;
  facebook_verified: boolean;
  twitter_verified: boolean;
  linkedin_verified: boolean;
  professional_profile: number;
  education_profile: number;
  socio_economico_profile: number;
  stability_profile: number;
  verified_income: number;
  blacklists: [];
  company: Company;
  insurance_info: [];
  mayor_medical_expense: boolean;
  minor_medical_expenses: boolean;
  car_insurance: boolean;
  life_insurance: boolean;
  principal_branch_address: any;
  constructor(data: any = {}) {
    data = data !== null ? data : {};
    data.company = data.company || {};
    this.company = new Company(data.company);
    this.id = data.id || '';
    this.income_source = data.income_source || '';
    this.everybodys_income = data.everybodys_income || 0;
    this.seniority_years = data.seniority_years || '';
    this.position = data.position || '';
    this.number_of_homies = data.number_of_homies;
    this.homies = data.home_application_income_homies || [];
    this.subsidiaries_number = data.subsidiaries_number || 0;
    this.current_living_situation = data.current_living_situation || '';
    this.number_of_cars = data.number_of_cars || 0;
    this.mortgage_credit = data.mortgage_credit || false;
    this.automotive_credit = data.automotive_credit || false;
    this.credit_card = data.credit_card || false;
    this.other_credits = data.other_credits || false;
    this.credit_card_last_digits = data.credit_card_last_digits || '';
    this.credit_card_issued_months = data.credit_card_issued_months;
    this.supermarket_expenses = data.supermarket_expenses || 0;
    this.leisure_expenses = data.leisure_expenses || 0;
    this.monthly_savings = data.monthly_savings;
    this.identity_checked = data.identity_checked || false;
    this.employment_checked = data.employment_checked || false;
    this.education_checked = data.education_checked || false;
    this.blacklisted = data.blacklisted || false;
    this.money_laundering_verified = data.money_laundering_verified || false;
    this.demands_verified = data.demands_verified || false;
    this.income_all_verified = data.income_all_verified || false;
    this.facebook_verified = data.facebook_verified || false;
    this.twitter_verified = data.twitter_verified || false;
    this.linkedin_verified = data.linkedin_verified || false;
    this.professional_profile = data.professional_profile || 0;
    this.education_profile = data.education_profile || 0;
    this.socio_economico_profile = data.socio_economico_profile || 0;
    this.stability_profile = data.stability_profile || 0;
    this.verified_income = data.verified_income || 0;
    this.blacklists = data.blacklists || [];
    this.insurance_info = data.insurance_info || [];
    this.mayor_medical_expense = data.mayor_medical_expense || false;
    this.minor_medical_expenses = data.minor_medical_expenses || false;
    this.car_insurance = data.car_insurance || false;
    this.life_insurance = data.life_insurance || false;
    this.principal_branch_address = data.principal_branch_address || {};
  }
}
